import { usePaletteTheme } from '../../context/paletteTheme'
import styles from './TextArea.module.scss'

export default function TextArea({label, value, onChangeFunc, elevation = 5}){
    const { theme } = usePaletteTheme()
    return (
        <div className={styles['form-textarea']}>
            <p>{label}</p>
            <textarea rows={5} value={value} onChange={onChangeFunc} style={theme.components.MuiPaper.styleOverrides['elevation'+elevation]}/>
        </div>
    )
}